import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface WrapperProps {
  $tone?: 'positive' | 'accent';
}

export const Wrapper = styled.div.withConfig({ componentId: 'sc-1soqver-0' })<WrapperProps>`
    ${(props) => props.theme.breakpoint.Lg} {
        display: flex;
        align-items: stretch;
    }
`;

export const Main = styled.div.withConfig({ componentId: 'sc-1soqver-1' })`
    ${(props) => props.theme.breakpoint.Lg} {
        flex: 1 1 auto;
    }
`;

export const Card = styled.div.withConfig({ componentId: 'sc-1soqver-2' })`
    display: flex;
    flex-direction: column;
    padding: ${size(2)};
    background-color: var(--c-bg-main);
    border: 1px solid var(--c-border-main);
    border-radius: ${size(2)};

    ${(props) => props.theme.breakpoint.LtLg} {
        margin-top: ${size(3)};
    }

    ${(props) => props.theme.breakpoint.Lg} {
        flex: 1 0 auto;
        width: 280px;
        max-width: 280px;
        padding: ${size(3)} ${size(2)};
        margin-left: ${size(3)};
    }
`;

export const CardBody = styled.div.withConfig({ componentId: 'sc-1soqver-3' })``;

interface OutputProps {
  $hasDisclaimer?: boolean;
}

export const Output = styled.div.withConfig({ componentId: 'sc-1soqver-4' })<OutputProps>`
    font-size: ${(props) => props.theme.font.size.large};
    font-weight: var(--font-weight-bold);

    ${({ $hasDisclaimer }) =>
      $hasDisclaimer &&
      css`
            &::after {
                content: "*";
            }
        `}
`;

export const OutputIcon = styled.span.attrs(() => ({
  'aria-hidden': 'true',
})).withConfig({ componentId: 'sc-1soqver-5' })`
    display: inline-block;
    vertical-align: middle;
    margin-right: 0.25em;
`;

export const OutputValue = styled.output.withConfig({ componentId: 'sc-1soqver-6' })`
    vertical-align: middle;
`;

export const Disclaimer = styled.div.withConfig({ componentId: 'sc-1soqver-7' })`
    margin-top: ${size(1)};
    font-size: ${(props) => props.theme.font.size.small};
    color: var(--c-text-muted);

    &::before {
        content: "*";
    }
`;

export const CardFooter = styled.footer.withConfig({ componentId: 'sc-1soqver-8' })`
    margin-top: auto;
    padding-top: ${size(2)};
`;
